import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import classnames from 'classnames';
import styles from './associationItem.module.scss';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import { DRMEntity } from './GenericAssociationTab';

interface AssociationItemProps {
  is_primary: boolean | undefined;
  entity: DRMEntity;
  onDelete: () => void;
  onUnselectPrimary: () => void;
  onSelectPrimary: () => void;
  isDeleting: boolean;
  children: React.ReactElement;
}

const AssociationItem = ({
  is_primary,
  entity,
  onDelete,
  onUnselectPrimary,
  onSelectPrimary,
  isDeleting,
  children,
}: AssociationItemProps) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  return (
    <div className={classnames(styles.itemContainer)}>
      <div className={classnames(styles.itemHeader)}>
        <div className={styles.titleContainer}>
          {children}
          {is_primary && (
            <div className={classnames(styles.primaryBox)}>Primary</div>
          )}
        </div>
        {(entity.is_editable || entity.is_deletable) && (
          <Dropdown
            className="d-inline mx-2"
            data-cy="association-item:association-actions-dropdown"
          >
            <Dropdown.Toggle
              id="dropdown-autoclose-true"
              variant="link"
              className={classnames('p-0', styles.actionBtn)}
            >
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu data-cy="association-item:association-actions-options">
              {entity.is_editable && is_primary && (
                <Dropdown.Item
                  className={styles.unselect}
                  onClick={onUnselectPrimary}
                >
                  Unselect Primary
                </Dropdown.Item>
              )}
              {entity.is_editable && !is_primary && (
                <Dropdown.Item
                  className={styles.unselect}
                  onClick={onSelectPrimary}
                >
                  Set as Primary
                </Dropdown.Item>
              )}
              {entity.is_deletable && (
                <Dropdown.Item onClick={() => setShowConfirmationModal(true)}>
                  Delete
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
      <ConfirmationModal
        show={showConfirmationModal}
        onCancel={() => setShowConfirmationModal(false)}
        onOk={async () => onDelete()}
        isLoading={isDeleting}
        okBtnText="Delete"
        title="Delete association"
      >
        <>Are you sure you want to delete this association?</>
      </ConfirmationModal>
    </div>
  );
};

export default AssociationItem;
